/**
 * Whether the brand has been set up, which is the one question the strip over
 * the form asks.
 *
 * The measure is the required fields and nothing else: they are what a save
 * cannot go without, so they are exactly the work standing between a workspace
 * and a finished brand. The optional ones — the logo, the address line the
 * design itself marks "(optional)", the UPI pair, the payment QR — are left
 * out on purpose, or a brand that is complete as far as the app is concerned
 * would still be told it is not.
 *
 * A field counts once it holds anything at all, and this deliberately does not
 * ask `fieldError` whether what it holds is acceptable. Validity is the Save
 * button's question, and it is answered where it can be acted on — against the
 * field, in words, once it has been visited. The strip cannot say which field
 * it is withholding credit from, so a strict test would leave it standing over
 * a form its owner can see nothing wrong with.
 *
 * That is not hypothetical. The backend normalises as it stores — `+91` onto
 * the numbers, the IFSC upper-cased — and `toNationalNumber` only takes the
 * code back off a value that is exactly `+91` and ten digits. A number stored
 * any other way comes back as something `mobileError` rejects, and a strict
 * test would hold the strip open for ever on a brand that is fully filled in.
 *
 * A pure function of the details in hand, so the strip holds no rules and costs
 * the page no extra call.
 */

import { BrandDetails } from "./types/brand.types";
import { REQUIRED_FIELDS } from "./validation";

export const isBrandSetUp = (details: BrandDetails): boolean =>
  // Trimmed, so a field holding nothing but spaces is the empty field it looks
  // like rather than a step taken.
  REQUIRED_FIELDS.every((field) => details[field].trim() !== "");

export default isBrandSetUp;
